import { useCallback, useRef } from 'react';

import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect';

/**
 * Stable Reference to a Callback Function that will not cause a re-render
 * but still ensures the callback updates if it changes.
 */
const useStableCallback = <T extends (...args: Parameters<T>) => ReturnType<T>>(cb: T) => {
    const ref = useRef<T>(cb);
    useIsomorphicLayoutEffect(() => {
        ref.current = cb;
    }, [cb]);

    return useCallback((...args: Parameters<T>) => {
        return ref.current?.(...args);
    }, []) as T;
};

export { useStableCallback };
